/** @format */

import content from "../../../assets/images/Content.svg";
import { numberFormat } from "../../../utils";
import { Container, CardSection, Empty, ImageContainer, CardHeading, CardContainer, Card } from "./styles";

interface CustomerTabProps {
  isCustomerActive: boolean;
  customers: any;
}
const CustomerTab = ({ isCustomerActive, customers }: CustomerTabProps) => {
  return (
    <Container hidden={!isCustomerActive}>
      <CardSection hidden={!isCustomerActive}>
        {customers?.length === 0 ? (
          <Empty>
            <ImageContainer>
              <img src={content} alt="shopping" />
            </ImageContainer>
            <p>No Customers Yet</p>
          </Empty>
        ) : (
          <div className="md:w-[24em] w-full">
            <CardHeading>
              <div>Customer</div>
              <div>Lifetime Value</div>
            </CardHeading>
            <CardContainer className="active">
              {customers?.map((transation: any) => (
                <Card className="" key={transation?.customerUuid}>
                  <h3>{transation?.number}</h3>
                  <div>{numberFormat(transation?.alltimeValue)}</div>
                </Card>
              ))}
            </CardContainer>
          </div>
        )}
      </CardSection>
    </Container>
  );
};

export default CustomerTab;
